import { useLocalStorage } from '../utils/useLocalStorage';

export type ViewMode = 'grid' | 'feed';

export function useViewMode() {
  return useLocalStorage<ViewMode>('hp-view-mode', 'grid');
}
